import { useNavigate, useSearchParams } from 'react-router-dom';
import { useProductMutations } from '../hooks/useProductMutations';
import { ProductForm } from '../components/ProductForm';
import { useDealerQuery } from '@/features/dealers/hooks/useDealerQuery';
import type { ProductFormOutput } from '../schemas/product.schema';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function ProductCreate() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const rawParent = searchParams.get('parent_dealer_id') ?? '';
    const parentDealerId = UUID_RE.test(rawParent) ? rawParent : '';
    const parentDealerQuery = useDealerQuery(parentDealerId);
    const { createMutation } = useProductMutations();

    const handleSubmit = (data: ProductFormOutput) => {
        createMutation.mutate(data, {
            onSuccess: (product) => navigate(`/smr-admin/products/${product.id}`),
        });
    };

    // If the URL had a valid UUID but the dealer didn't resolve (404), clear the prefill.
    const resolvedDealer = parentDealerQuery.data ?? null;
    const effectiveParentId = resolvedDealer ? parentDealerId : '';

    return (
        <section className="space-y-4">
            <h1 className="text-2xl font-semibold">New Product</h1>
            <ProductForm
                initialValues={effectiveParentId ? { parent_dealer_id: effectiveParentId } : undefined}
                selectedDealer={resolvedDealer}
                onSubmit={handleSubmit}
                isLoading={createMutation.isPending}
                submitLabel="Create Product"
                onCancel={() => navigate('/smr-admin/products')}
            />
        </section>
    );
}
